var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center justify-between font-inter tw-text-sm tw-gap-6"},[_c('div',{staticClass:"tw-whitespace-nowrap tw-font-medium"},[_vm._v("Include in presentation")]),_vm._v(" "),_c('o-switch',{attrs:{"value":_vm.isIncluded,"variant":"success","position":"left"},on:{"input":_vm.handleToggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }